import { FC } from 'react';

import { Card } from 'components/parts/Card';
import Clear from 'images/area/clear.svg';
import Clue0 from 'images/icon/clue0.svg';
import Clue1 from 'images/icon/clue1.svg';
import Clue2 from 'images/icon/clue2.svg';
import Clue3 from 'images/icon/clue3.svg';
import ActiveIcon from 'images/icon/difficulty-level_active.svg';
import DeactiveIcon from 'images/icon/difficulty-level_deactive.svg';

import styles from './AreaCard.module.scss';

export type AreaCardItem = {
  id: string;
  name: string;
  areaNo?: number;
  difficultyLevel?: string;
  clueStatus?: {
    clueCount: number | undefined;
    foundClue_1: boolean;
    foundClue_2: boolean;
    foundClue_3: boolean;
  };
  cleared?: boolean;
  isHamadori: boolean;
  missionNo?: number;
};

export const AreaCard: FC<{ cardItem: AreaCardItem }> = ({ cardItem }) => {
  const { id, name, difficultyLevel, clueStatus, cleared, isHamadori, missionNo } = cardItem;

  const getDifficultyIndicator = (level: string) => {
    const levelNumber = Number(level);
    switch (levelNumber) {
      case 1:
        return (
          <div className={styles.difficultyLevel}>
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={DeactiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={DeactiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <span className={styles.sronly}>難易度1</span>
          </div>
        );
      case 2:
        return (
          <div className={styles.difficultyLevel}>
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={DeactiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <span className={styles.sronly}>難易度2</span>
          </div>
        );
      case 3:
        return (
          <div className={styles.difficultyLevel}>
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <img src={ActiveIcon} alt="" className={styles.difficultyLevelIcon} />
            <span className={styles.sronly}>難易度3</span>
          </div>
        );
      default:
        return 'Invalid difficulty level';
    }
  };

  return (
    <Card to={`/area/${id}${missionNo !== undefined ? `#mission-${missionNo}` : ''}`}>
      <div className={`${styles.root} ${isHamadori ? styles.hamadori : ''}`}>
        <div className={styles.first}>
          <p className={styles.no}>{id}</p>
        </div>
        <div className={styles.second}>
          <div dangerouslySetInnerHTML={{ __html: name }} className={styles.title} />
          {difficultyLevel && getDifficultyIndicator(difficultyLevel)}
        </div>
        <div className={styles.third}>
          {clueStatus && (
            <ol className={styles.clue}>
              <li className={styles.clueItem}>
                {clueStatus.foundClue_1 ? (
                  <img src={Clue1} alt="手がかり1：取得している" className={styles.clueIcon} />
                ) : (
                  <img src={Clue0} alt="手がかり1：取得していない" className={styles.clueIcon} />
                )}
              </li>
              {/* ヒント2つ以上ある場合に表示する */}
              {(clueStatus.clueCount || 3) >= 2 && (
                <li className={styles.clueItem}>
                  {clueStatus.foundClue_2 ? (
                    <img src={Clue2} alt="手がかり2：取得している" className={styles.clueIcon} />
                  ) : (
                    <img src={Clue0} alt="手がかり2：取得していない" className={styles.clueIcon} />
                  )}
                </li>
              )}
              {/* ヒント３つある場合に表示する */}
              {(clueStatus.clueCount || 3) >= 3 && (
                <li className={styles.clueItem}>
                  {clueStatus.foundClue_3 ? (
                    <img src={Clue3} alt="手がかり3：取得している" className={styles.clueIcon} />
                  ) : (
                    <img src={Clue0} alt="手がかり3：取得していない" className={styles.clueIcon} />
                  )}
                </li>
              )}
            </ol>
          )}
          {cleared && <img src={Clear} className={styles.clear} alt="CLEAR" />}
        </div>
      </div>
    </Card>
  );
};
